import type { LngLatBoundsLike } from 'mapbox-gl';

export const GEOGRAPHIC_CH_BBOX: LngLatBoundsLike = [
  [5.96, 45.82],
  [10.49, 47.81],
];
